const React = require('react');
const {openPopupWindow} = require('../../../../../../../emitters/popup');
const Popup = require('../../../../../Popup/C');

const WalletForm = require('../components/WalletForm');

module.exports = (data, update) => {
  openPopupWindow((setPopupState, popup) => {
    const {close} = popup;

    return (stateOfPopup) => {
      return (
        <Popup
          caption={(
            <div className="layoutRow fhaS fvaC w">
              <div>Edit Wallet</div>
            </div>
          )}
        >
          <WalletForm data={data} />
        </Popup>
      )
    }
  })
}
